import { Box, BoxProps, Heading } from '@chakra-ui/react'
import React from 'react'

const CardFormAlt: React.FC<{ title?: string } & BoxProps> = ({
  children,
  title,
  ...props
}) => {
  return (
    <Box
      mx="auto"
      bgColor="#fff"
      boxShadow="rgba(0, 0, 0, 0.04) 0px 1px 4px"
      borderRadius="8px"
      padding="26px 24px"
      flex={1}
      {...props}
    >
      {title && (
        <Heading as="h3" fontSize="20px" mb="10">
          {title}
        </Heading>
      )}
      {children}
    </Box>
  )
}

export default CardFormAlt
